import * as React from "react"
import { Badge, Box } from "@mui/material"

import { STOCK_STATUS } from "../../@constants"

const STOCK_FACTORY = {
	[STOCK_STATUS.NOT_LISTED]: 'disabled.darker' ,
	[STOCK_STATUS.STOCK]: '#54d62c',
	[STOCK_STATUS.OUT_OF_STOCK]: '#FF4842' ,
	[STOCK_STATUS.DESLISTED]: 'disabled.light',
	[STOCK_STATUS.NOT_LAUNCHED]: '#2196F3'
}


export default function stockStatusColumn() {
	return [{
		name: 'stock', label: 'Stock Status',
		options: {
			display: 'excluded',
			customBodyRowRender: value => {
				if (value === STOCK_STATUS.STOCK) return 'In Stock'
				if (value === STOCK_STATUS.OUT_OF_STOCK) return 'Out of Stock'
				if (value === STOCK_STATUS.DESLISTED) return 'Deslisted'
				if (value === STOCK_STATUS.NOT_LISTED) return 'Not Listed'
				if (value === STOCK_STATUS.NOT_LAUNCHED) return 'Not Launched'
			}
		}
	}, {
		name: 'stock', label: 'Stock Status',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'normal', maxWidth: 30 }
			}),
			customBodyRowRender: value => {
				return <Box sx={{ textAlign: 'center' }}>
					<Badge sx={{ span: { backgroundColor: STOCK_FACTORY[value] } }} badgeContent=" " />
				</Box>
			}
		}
	}]
}